import React from 'react';
import { Link } from 'react-router-dom';

function IntroNav({ onConsultClick }) {
  return (
    <nav className="sticky top-0 z-50 w-full border-b border-[#e7f3eb] dark:border-[#2a4535] bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md">
      <div className="px-4 md:px-10 py-3 flex items-center justify-between max-w-[1280px] mx-auto">
        <div className="flex items-center gap-4">
          <Link to="/" className="size-8 flex items-center justify-center text-primary">
            <span className="material-symbols-outlined !text-3xl">local_florist</span>
          </Link>
          <Link to="/" className="text-lg font-bold leading-tight tracking-[-0.015em] hidden sm:block">
            플라워 플랫폼
          </Link>
        </div>
        <div className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-8">
            <a className="text-sm font-medium hover:text-primary transition-colors" href="#vision">비전</a>
            <a className="text-sm font-medium hover:text-primary transition-colors" href="#profit">수익 모델</a>
            <a className="text-sm font-medium hover:text-primary transition-colors" href="#partners">성공 파트너</a>
            <Link to="/adminlogin" className="text-sm font-medium hover:text-primary transition-colors">로그인</Link>
          </div>
          <button
            onClick={onConsultClick}
            className="flex min-w-[84px] cursor-pointer items-center justify-center rounded-lg h-10 px-6 bg-primary text-primary-contrast dark:text-[#0e1b12] text-sm font-bold shadow-sm hover:bg-opacity-90 transition-all"
          >
            <span>가맹 문의</span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default IntroNav;
